import { forwardRef, useImperativeHandle } from 'react';
import * as XLSX from 'xlsx';
import { request } from '../helpers/api';
import { toast } from 'react-toastify';
import { isNonRootFolder, getName } from "../helpers/functions";
import PropTypes from "prop-types";

const NomenclaturesExporter = forwardRef(({ node }, ref) => {
    useImperativeHandle(ref, () => ({
        exportFile: async () => {
            if (!isNonRootFolder(node)) {
                toast.error("Töitä voi viedä vain alikansioista, ei juurikansiosta.");
                return;
            }

            try {
                const res = await request(
                "nodes/exportNomenclatures",
                "get",
                null,
                { parentId: node.id } // registryVersion auto-injected by request()
            );

                const items = res?.data?.items ?? [];

                if (items.length === 0) {
                    toast.error("Ei vietäviä töitä.");
                    return;
                }

                const folderName = getName(node) || "nomenclatures";

                //layout
                const aoa = [
                    ["", folderName],
                    ["Koodi", "Nimi", "Työtunnit", "Yksikkö"],
                    ...items.map((i) => [
                        i.code ?? "",
                        i.name ?? "",
                        i.duration ?? "",
                        i.unit ?? "",
                    ]),
                ];

                const worksheet = XLSX.utils.aoa_to_sheet(aoa);

                // column widths
                worksheet["!cols"] = [
                    { wch: 16 },
                    { wch: 75 },
                    { wch: 12 },
                    { wch: 12 },
                ];

                const workbook = XLSX.utils.book_new();
                XLSX.utils.book_append_sheet(workbook, worksheet, "Nomenclatures");

                const safeName = String(folderName).replaceAll(/[\\/:*?"<>|]/g, "_") //clean file name
                XLSX.writeFile(workbook, `${safeName}.xlsx`);

                toast.success(`Tiedosto ${safeName}.xlsx luotu onnistuneesti.`);
            } catch (error) { const message = error?.response?.data?.message ?? error?.message ?? "Tiedoston vienti epäonnistui."; toast.error(message); }
        }
    }));
    return null;
});

NomenclaturesExporter.displayName = "NomenclaturesExporter";

NomenclaturesExporter.propTypes = {
    node: PropTypes.shape({
        id: PropTypes.string.isRequired,
        path: PropTypes.string,
    }).isRequired,
};

export default NomenclaturesExporter;